import { CircularProgress, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useDataProvider, useMasterData } from '@ui-framework/index';
import { useEffect, useState } from 'react';
import TextLabelValue from '../components/TextLabelValue';

function ServiceDispatchSettingInfo({ sp }) {
  const masterData = useMasterData();
  const [loading, setLoading] = useState(true);
  const [providerType, setProviderType] = useState(true);
  const dispatchMethod =
    masterData?.dispatchMethods.find(d => d.value === sp.dispatchMethod)
      ?.label || '';

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);

  const fetchServiceProviderType = async () => {
    setLoading(true);
    const url = `${getApiUrl()}/sxcl/v1/service-provider-types?limit=50`;
    const response = await get(url);
    if (response?.ok) {
      setLoading(false);
      setProviderType(
        response?.data?.data?.find(r => r.typeCode === sp?.serviceProviderType)
          ?.typeName || '-',
      );
    }
    setLoading(false);
    return null;
  };

  useEffect(() => {
    fetchServiceProviderType();
  }, [sp?.id]);

  return (
    <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
      <TextLabelValue
        id="SP_MAP_MODAL_SP_PROVIDER_TYPE"
        defaultMessage={
          <FormattedMessage
            id="SERVICE_PROVIDER_TYPE"
            defaultMessage="Service Provider Type"
          />
        }
        value={loading ? <CircularProgress /> : providerType || '-'}
      />
      <TextLabelValue
        containerProps={{ sx: { textAlign: 'right' } }}
        id="SP_MAP_MODAL_SP_PROVIDER_DISPATCH_METHOD"
        defaultMessage={
          <FormattedMessage
            id="DISPATCH_METHOD"
            defaultMessage="Dispatch Method"
          />
        }
        value={dispatchMethod || '-'}
      />
    </Stack>
  );
}

export default ServiceDispatchSettingInfo;
